export type propKey = string | number;

/* eslint-disable no-undefined */

export const getProp = (
    object: Record<propKey, unknown>,
    path: propKey[],
    defaultVal?: unknown
): unknown => {
    if (path.length === 0) {
        return object === undefined ? defaultVal : object;
    }
    if (object === null || object === undefined || typeof object[path[0]] === 'undefined') {
        return defaultVal;
    }

    return getProp(object[path.shift()!] as Record<propKey, unknown>, path, defaultVal);
};
